<ion-grid>
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336">
				<!-- <ng-container *ngIf="events.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container> -->
				<ion-row>
					<ion-col col="12">
						<div *ngIf="showLoader" class="loading-indicator">
							<dx-load-indicator
								id="medium-indicator"
								height="40"
								width="40"
							></dx-load-indicator>
						</div>
						<dx-data-grid
							id="gridContainer"
							[dataSource]="allEvents"
							[allowColumnResizing]="true"
							[columnAutoWidth]="true"
							[showBorders]="true"
							(onOptionChanged)="onPageChanged($event)"
						>
							<div>
								<dxo-load-panel [enabled]="false">
									<dxo-position
										my="center"
										at="center"
										of="gridContainer"
									></dxo-position>
								</dxo-load-panel>
							</div>

							<!-- <dxo-paging [pageSize]="pageSize"></dxo-paging>
							<dxo-pager
								[visible]="true"
								[showPageSizeSelector]="true"
								[allowedPageSizes]="[10, 20, 50, 100]"
								[showNavigationButtons]="true"
								[showInfo]="true"
							></dxo-pager> -->

							<dxo-paging [enabled]="true" [pageSize]="pageSize"></dxo-paging>
							<dxo-pager
								tabindex="-1"
								[showNavigationButtons]="true"
								[showPageSizeSelector]="true"
								[allowedPageSizes]="[20]"
								[showInfo]="true"
								[visible]="true"
							>
							</dxo-pager>
							<span *ngIf="true">
								<dxo-remote-operations [groupPaging]="true" [sorting]="true">
								</dxo-remote-operations>
							</span>

							<dxo-search-panel
								[visible]="true"
								[width]="240"
								placeholder="Search..."
							></dxo-search-panel>
							<dxo-header-filter></dxo-header-filter>
							<dxo-column-chooser
								[enabled]="true"
								mode="select"
							></dxo-column-chooser>
							<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

							<dxi-column
								caption="Action"
								dataField="userId"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="cellTemplate"
								[width]="200"
								[fixed]="true"
								[visible]="true"
							>
							</dxi-column>
							<dxi-column
								caption="Event Status"
								dataField="postId"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="cellTemplate3"
								[width]="100"
								[fixed]="true"
								[visible]="true"
							>
							</dxi-column>
							<dxi-column
								caption="Event Date"
								dataField="eventDate"
								cellTemplate="cellTemplate5"
								[width]="100"
								[fixed]="true"
							>
							</dxi-column>
							<dxi-column
								dataField="eventTitle"
								caption="Title"
								[width]="230"
								[fixed]="true"
							></dxi-column>

							<dxi-column
								caption="Communities"
								dataField="communityNames"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="cellTemplate2"
								[width]="150"
								[fixed]="true"
								[visible]="true"
							>
							</dxi-column>
							<!-- <dxi-column
								caption="Event Tags"
								dataField="tagOnTheEvent"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="eventTags"
								[width]="150"
								[fixed]="true"
								[visible]="true"
							>
							</dxi-column> -->

							<dxi-column
								dataField="postDescription"
								caption="Post Description"
								[width]="230"
								[fixed]="true"
								cellTemplate="cellTemplate4"
							></dxi-column>
							<dxi-column
								dataField="zoom"
								caption="Zoom Link"
								[width]="230"
								[fixed]="true"
							></dxi-column>
							<dxi-column
								dataField="recordingUrl"
								caption="Recording Link"
								[width]="230"
								[fixed]="true"
								[visible]="eventTimeFrame === 'past'"
							></dxi-column>
							<dxi-column
								dataField="timeZone"
								caption="Timezone"
								[width]="230"
								[fixed]="true"
								[visible]="false"
							>
							</dxi-column>

							<dxi-column
								dataField="eventCategoryName"
								caption="Event Category Name"
								[width]="230"
							></dxi-column>

							<div *dxTemplate="let d of 'cellTemplate'">
								<div class="text-center cursor-pointer">
									<span
										(click)="editEvent(d.data)"
										*ngIf="eventTimeFrame==='upcoming'"
										>Edit
									</span>
									<span
										(click)="cancelEvent(d.data)"
										*ngIf="!d.data.status && eventTimeFrame==='upcoming'"
										>/ Cancel
									</span>
									<span
										(click)="addRecording(d.data)"
										*ngIf="eventTimeFrame==='past'"
									>
										Add recording</span
									>
									<span
										appConfirmBox
										(learnDelete)="onDelete(d.data)"
										title="Delete Event"
										subTitle="Are you sure you want to delete this event ?"
										class="Body_S text-right curso"
									>
										/ Delete
									</span>
								</div>
							</div>
							<div *dxTemplate="let d of 'cellTemplate4'" class="td-height">
								<div [innerHTML]="d.data.postDescription"></div>
							</div>
							<div *dxTemplate="let d of 'cellTemplate5'" class="td-height">
								{{ d.data.eventDate | date:'dd MMM yyyy' }}
							</div>
							<div *dxTemplate="let d of 'cellTemplate3'">
								<div class="text-center cursor-pointer">
									<span *ngIf="d.data.status">canceled</span>
									<span
										*ngIf="eventTimeFrame==='upcoming' && checkLive(d.data.eventDate, d.data.eventEndDate)"
									>
										Live
									</span>
								</div>
							</div>

							<div *dxTemplate="let d of 'cellTemplate2'">
								<ion-select
									name="communities"
									id="community"
									interface="popover"
									placeholder="Communities"
									[selectedText]="d.data.communityNames[0]"
								>
									<ng-container *ngFor="let community of d.data.communityNames">
										<ion-select-option [value]="community" selectedText
											>{{community}}</ion-select-option
										>
									</ng-container>
								</ion-select>
							</div>

							<!-- <div *dxTemplate="let d of 'eventTags'">
								<ion-select
									name="tags"
									id="tags"
									interface="popover"
									placeholder="Tags"
									[selectedText]="d.data.tagOnTheEvent[0]"
								>
									<ng-container *ngFor="let community of d.data.tagOnTheEvent">
										<ion-select-option [value]="community" selectedText
											>{{community}}</ion-select-option
										>
									</ng-container>
								</ion-select>
							</div> -->
							<dxo-toolbar>
								<dxi-item location="before">
									<div *dxTemplate class="informer">
										<ion-button (click)="addEvent()"
											><ion-icon name="add-outline"></ion-icon
										></ion-button>
									</div>
								</dxi-item>
								<dxi-item location="before">
									<div *dxTemplate class="informer">
										<p class="Heading_M">Add New Event</p>
									</div>
								</dxi-item>

								<dxi-item>
									<ion-buttons class="center">
										Select Time Frame :
										<ion-select
											placeholder="Select Time Frame"
											interface="popover"
											(ionChange)="changeEventTimeFrame($event)"
											value="pending"
											[selectedText]="eventTimeFrame"
										>
											<ion-select-option value="upcoming" selectedText
												>Upcoming</ion-select-option
											>
											<ion-select-option value="past">Past</ion-select-option>
										</ion-select>
									</ion-buttons>
								</dxi-item>
								<dxi-item name="columnChooserButton"></dxi-item>
								<dxi-item name="searchPanel"></dxi-item>
							</dxo-toolbar>
						</dx-data-grid>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>
